import { Group } from '@visx/group';
import { Pie } from '@visx/shape';
import cn from 'classnames';
import React, { FC } from 'react';

import { CircleDivisionsLegend } from '@/Components/Partials/Charts/CircleDivisions/CircleDivisionsLegend';
import { DefaultCircleDivisionsCenterContent } from '@/Components/Partials/Charts/CircleDivisions/DefaultCircleDivisionsCenterContent';
import { calculateTotalValue } from '@/Components/Partials/Charts/CircleDivisions/lib/calculateTotalValue';
import { CircleDivisionProps } from '@/Components/Partials/Charts/CircleDivisions/types';

import S from './styles.module.scss';

export const CircleDivisions: FC<CircleDivisionProps> = ({ data, className, textTotal, showLegend = true }) => {
    const pieSortValues = (a: number, b: number) => a - b;

    const width = 200,
        height = 200,
        margin = { top: 20, right: 20, bottom: 20, left: 20 };

    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;
    const radius = width / 2 - 30;
    const centerY = innerHeight / 2;
    const centerX = innerWidth / 2;
    const top = centerY + margin.top;
    const left = centerX + margin.left;

    const containerClassName = cn(S.circle_divisions, className);

    return (
        <div className={containerClassName}>
            <svg style={{ top, left, overflow: 'visible', position: 'relative', width: 200, height: 200 }}>
                {data && (
                    <Group>
                        <Pie
                            data={data}
                            pieSortValues={pieSortValues}
                            outerRadius={radius}
                            innerRadius={radius + 30}
                            pieValue={(d) => d.value}
                            startAngle={(3 * Math.PI) / 2}
                            endAngle={-Math.PI}
                        >
                            {(pie) =>
                                pie.arcs.map((arc) => {
                                    const { color } = arc.data;
                                    const arcPath = pie.path(arc);

                                    return (
                                        <g key={`arc-d-${color}-${arc.data.value}`}>
                                            <path d={arcPath ?? undefined} fill={color} />
                                        </g>
                                    );
                                })
                            }
                        </Pie>
                        <DefaultCircleDivisionsCenterContent total={calculateTotalValue(data)} text={textTotal} />
                    </Group>
                )}
            </svg>
            {showLegend && <CircleDivisionsLegend legendData={data} />}
        </div>
    );
};
